/**
 * 公共接口
 */
import request from '@/utils/request';

/**
 * 导出模板
 * @param {*} fileName 文件名称
 * @example customerSku.xlsx
 * @returns "fileName": "http://118.24.107.23:8082/crmebimage/upploadf/excel/template/customerSku.xlsx"
 */
export function excelTemplateApi(fileName) {
  return request({
    url: "/admin/export/excel/template",
    method: 'GET',
    params: {
      fileName: fileName
    }
  });
}

/**
 * 获取字典信息
 * @param {Object} params  { group:product_certification }
 * @example group { group:product_certification }
 * @returns { "code": 0,"data": {},"message": ""}
 */
export function dictionaryGetListApi(params) {
  return request({
    url: "/admin/system/dictionary/getList",
    method: 'GET',
    params: params
  });
}